<div class="container content-terms">
    <div class="content-wp-page" [class.content-terms-dialog]="openDialog" [innerHTML]="contentPage"></div>
</div>